import React from 'react'
import { Link, useParams } from 'react-router-dom'

import { useGetPaginatedFormulariosQuery } from '../../../../store/api/endpoints/formularioSuscripcionApiSlice'

import HeaderVista from '../../../elementos/HeaderVista'
import TablaPaginada2026 from '../../../elementos/TablaPaginada2026'
import MenuOptions from '../../../elementos/MenuOptions'

import Button from '@mui/material/Button'
import { Breadcrumbs, Typography, Box, Stack } from '@mui/material'

import AddIcon from '@mui/icons-material/Add'
import CreateIcon from '@mui/icons-material/Create'
import DeleteIcon from '@mui/icons-material/Delete'
import CircleIcon from '@mui/icons-material/Circle'
import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined'
import HelpSection from './FormularioSuscripcionHelpSection'


export default function FormularioSuscripcionPage() {

    // 1. Capturamos el estado desde la URL. 
    // Si entran a /formularios a secas, por defecto será 'todos'
    const { estadoFiltro = 'vigentes' } = useParams()

    const thead = [
        { label: "Vigente", align: "center", ordenable: false },
        { label: "Título", align: "left", ordenable: true },
        { label: "Importe", align: "center", ordenable: true },
        { label: "Desde", align: "center", ordenable: true },
        { label: "Hasta", align: "center", ordenable: true },
        { label: "Acciones", align: "center", ordenable: false }
    ]

    const botones = [
        { color: "primary", icono: <CreateIcon />, ruta: "/formularios/formulario-suscripcion/editar/", valor: '_id' },
        { color: "error", icono: <DeleteIcon />, ruta: "/formularios/formulario-suscripcion/eliminar/", valor: '_id' }
    ]

    const tbody = [
        { tipo: "estado", valor: "vigente" },
        { tipo: "texto", valor: "titulo" },
        { tipo: "texto", valor: "importe" },
        { tipo: "fechahora", valor: "desde" },
        { tipo: "fechahora", valor: "hasta" },
        { tipo: "botones", valor: botones }
    ]

    // 2. Determinamos el título a mostrar en el menú desplegable según la URL actual
    const getTituloFiltro = () => {
        const titulos = {
            'todos': 'Todos',
            'vigentes': 'Vigentes',
            'vencidos': 'Vencidos'
        }
        return titulos[estadoFiltro] || 'Vigentes'
    }

    return (
        <>
            <HeaderVista
                titulo={
                    <Breadcrumbs aria-label="breadcrumb">
                        <Typography color="text.primary">Suscripciones</Typography>
                    </Breadcrumbs>
                }
                icon={<InventoryOutlinedIcon />}
                // Agrupamos el MenuOptions y el botón Nuevo usando un Box con flexbox
                end={
                    <Stack
                        direction="row"
                        spacing={2}
                        sx={{
                            justifyContent: "flex-end", // Cambiado de center a flex-end
                            alignItems: "center",     // Usualmente mejor centrado verticalmente
                            width: "100%",             // Asegura que ocupe el ancho del Grid
                        }}
                    >
                        <MenuOptions
                            titulo={getTituloFiltro()}
                            opciones={[
                                {
                                    titulo: "Todos",
                                    icono: <CircleIcon style={{ color: 'black' }} />,
                                    to: '/formularios/formulario-suscripcion/todos',
                                },
                                {
                                    titulo: "Vigentes",
                                    icono: <CircleIcon style={{ color: 'green' }} />,
                                    to: '/formularios/formulario-suscripcion/vigentes',
                                },
                                {
                                    titulo: "Vencidos",
                                    icono: <CircleIcon style={{ color: 'red' }} />,
                                    to: '/formularios/formulario-suscripcion/vencidos',
                                }
                            ]}
                        />
                        <Link to="/formularios/formulario-suscripcion/crear">
                            <Button
                                variant="outlined"
                                size="small"
                                startIcon={<AddIcon />}
                            >
                                Nuevo
                            </Button>
                        </Link>
                    </Stack>
                }
            />

            <HelpSection />

            <TablaPaginada2026
                api={useGetPaginatedFormulariosQuery}
                thead={thead}
                tbody={tbody}
                orderDefault={[1, 1]}
                // 3. Le pasamos el parámetro extraído de la URL a RTK Query
                extraParams={{ estado: estadoFiltro }}
            />
        </>
    )
}